// export const data = {
//   menu: {

// };

export const PORTFOLIO = [
  {
    id: 0,
    name: "全部",
  },
  {
    id: 1,
    name: "智能混剪",
  },
  // {
  //   id: 1,
  //   name: "智能魔剪",
  // },
  // {
  //   id: 2,
  //   name: "一键成片",
  // },
  {
    id: 5,
    name: "图集",
  },
  {
    id: 6,
    name: "数字人",
  },
  {
    id: 4,
    name: "文件夹",
  },
];

export const MATERIALTABLIST = [
  {
    name: "全部",
    id: undefined,
  },
  {
    name: "视频",
    id: 1,
  },
  {
    name: "音频",
    id: 2,
  },
  {
    name: "图片",
    id: 3,
  },
  // {
  //   name: "文件夹",
  //   id: 4,
  // },
];

export const ENGINEERING = [
  {
    id: 0,
    name: "全部",
  },
  {
    id: 1,
    name: "智能魔剪",
  },
  // {
  //   id: 2,
  //   name: "一键成片",
  // },
  {
    id: 3,
    name: "图文创作",
  },
  {
    id: 6,
    name: "AI讯剪",
  },
  {
    id: 5,
    name: "AI云剪",
  },
];


export const COPYWRITER = [
  {
    id: 0,
    name: "全部",
  },
  {
    id: 1,
    name: "组合文案",
  },
  {
    id: 2,
    name: "智能文案",
  },
  {
    id: 3,
    name: "爆款解说",
  },
  // {
  //   id: 4,
  //   name: "文件夹",
  // },
];
